import ZiBuzzPrototype from "./ZiBuzzPrototype";

export default ZiBuzzPrototype;
